export { default } from './ListItemSecondaryAction';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/ListItemSecondaryAction/index.js
// module id = 340
// module chunks = 0